const WATCHLIST_CACHE_KEY = "ai_watchlist_cache";
const WATCHLIST_CACHE_VERSION = 2;
const WATCHLIST_CACHE_MAX_AGE_MS = 5 * 60 * 1000;

export const getWatchlistCache = () => {
  try {
    const cached = JSON.parse(localStorage.getItem(WATCHLIST_CACHE_KEY));
    const isCurrentVersion = cached?.version === WATCHLIST_CACHE_VERSION;
    const isFresh = Date.now() - cached?.cachedAt < WATCHLIST_CACHE_MAX_AGE_MS;

    if (isCurrentVersion && isFresh) {
      return cached;
    }
  } catch (error) {
    // Invalid cache data should be replaced by the next API response.
  }

  localStorage.removeItem(WATCHLIST_CACHE_KEY);
  return null;
};

export const setWatchlistCache = ({ watch_list, news_pairs }) => {
  localStorage.setItem(WATCHLIST_CACHE_KEY, JSON.stringify({
    version: WATCHLIST_CACHE_VERSION,
    cachedAt: Date.now(),
    watch_list,
    news_pairs
  }));
};
